export const AUD_DESKTOP_MENU = 'aud_desktop_bx606_new_head_menu';
export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';

export const EXPERIMENTS = [AUD_DESKTOP_MENU, PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT];
